import React from 'react'
import ButtonPanel from '../../../../../ButtonPanel'
// When it runs build, the src folder is deleted, so the package.json is
// on the same level of components and we need to remove a segment ../ to get components' version

import './index.scss'

const SettingsPanel = (props) => {
  const {
    settingPanelContent,
    getIcon,
    location
  } = props

  const renderPanel = () => {
    return (
      <>
        {settingPanelContent}
      </>
    )
  }

  return (
    <ButtonPanel
      closePanel={location}
      panelClassname='ublique-settings-panel'
      iconComponent={getIcon}
      contentComponent={renderPanel()}
      id='BDD_setting_area_button'
    />
  )
}
export default SettingsPanel
